import { fbAuth } from '@/services/auth'
import db from '@/services/db'

class AuthStatusCheck {
  /**
  * Init and read required data from db then check access
  * @param {object} store - vuex store instance
  * @param {object} route - router instance
  */
  constructor (store, router) {
    this.$store = store
    this.$router = router
    this.ls = window.localStorage

    this.init()
  }

  /**
  * Init function that handle check
  */
  async init () {
    this.$store.commit('reset')

    await new Promise((resolve) => {
      db.root.ref('isNFLApp').once('value', (snapshot) => {
        this.isNFLApp = false
        resolve()
      })
    })
    //check if this dashboard uses workspaces

    await new Promise((resolve, reject) => {
      db.root.ref('dashboards/'+ localStorage.lastDash + '/workspaceAccess')
        .once('value', (snapshot) => {
          window.workspaceAccess = snapshot.val()
          console.log('workspace access is ' + workspaceAccess);

          resolve()
        }, (err) => {
          reject(err)
        })
    }).catch((err) => {
      console.error(err)
    })
    fbAuth().onAuthStateChanged((fbUser) => {
      this.$store.commit('setAuthStateChecked', false)

      this.curPath = document.location.pathname
      this.user = fbUser

      if (fbUser) {
        const user = {
          uid: this.user.uid,
          displayName: this.user.displayName,
          photoURL: this.user.photoURL,
          email: this.user.email,
          emailVerified: this.user.emailVerified,
          phoneNumber: this.user.phoneNumber,
          isAnonymous: this.user.isAnonymous,
          providerData: this.user.providerData
        }

        window.fbUser = user
      } else {
        window.fbUser = null
      }

      if (this.user) this.$store.commit('setUserId', this.user.uid)

      if (this.isNFLApp) this.handleNFLAuthScenario()
      else this.handleDefaultAuthScenario()

      if (this.isNFLApp) this.$store.commit('setAsNFLApp', true)
      else this.$store.commit('setAsNFLApp', false)
      this.$store.commit('setAuthStateChecked', true)
    })
  }

  // Default Auth Scenario

  handleDefaultAuthScenario () {
    if (this.user) this.handleDefaultAuthorized()
    else this.handleDefaultUnauthorized()
  }

  handleDefaultAuthorized () {
    const pageName = this.$router.history.current.name
    const lastDash = localStorage.lastDash

    if (lastDash && pageName !==  'setWorkspace' && pageName !==  'Home') {
      if (window.workspaceAccess) {
        console.log('this is a workspace dashboard take user to workspace select');
        if (window.workspaceLink && localStorage.workspace && fbUser) {
          console.log('there is a link and a workspace set send user to their workspace');
          this.$router.push('/workspace/'+ localStorage.workspace +'/dashboard/' + lastDash)
        }
        else {
          console.log('no workspace link on workspace dash take user to select workspace');
          this.$router.push('/dashboard/' + lastDash +'/workspaces')
        }
      }
    } else {
      if (
        pageName !== 'Dashboard' &&
        pageName !== 'Forbidden' &&
        pageName !==  'setWorkspace'
      ) {
        console.log('User authenticated but has no access to workspace on workspace dash');
        this.$router.push('/home')
      }
      else
      {
        console.log('no workspace but this is open registration dashboard')
        this.$router.push('/dashboard/' + lastDash)
      }



    }
    //this.$router.push('/dashboard/' + lastDash)
  }

  handleDefaultUnauthorized () {
    const pageName = this.$router.history.current.name
    if (pageName !== 'Dashboard' && pageName !== 'Forbidden'  && pageName !==  'setWorkspace') {
      if (this.curPath !== '/auth') this.$router.push('/auth')
    }
  }

  // NFL Auth Scenario

  handleNFLAuthScenario () {
    new Promise((resolve) => {
      db.root.ref('redirects').once('value', (snapshot) => {
        this.redirects = snapshot.val()
        resolve()
      })
    }).then(() => {
      return new Promise((resolve) => {
        db.root.ref('access/Admin').once('value', (snapshot) => {
          this.admins = Object.keys(snapshot.val())
          resolve()
        })
      })
    }).then(() => {
      if (this.user) this.handleNFLAuthorized()
      else this.handleNFLUnauthorized()
    })
  }

  /**
  * Method handles authorized users
  */
  handleNFLAuthorized () {
    if (this.user.isAnonymous) {
      this.$store.commit('markUserAsAnonymous', true)
    } else {
      this.$store.commit('markUserAsAnonymous', false)
    }

    if (~this.admins.indexOf(this.user.uid)) {
      if (this.$router.history.current.name !== 'Dashboard') {
        console.log('handle nfl auth send to home')
        this.$router.push('/home')
      }
    } else {
      if (this.$router.history.current.name !== 'Dashboard') {
        this.$router.push(this.redirects.defaultDash)
      }
    }
  }

  /**
  * Method handles unauthorized users
  */
  handleNFLUnauthorized () {
    this.ls.removeItem('uid')

    if (this.curPath !== '/auth') {
      document.location = this.redirects.toSSO
    }
  }
}

export default AuthStatusCheck
